<template>
  <div class="home-popup-mask">
    <div class="home-popup">
      <span class="close-btn" @click="$emit('close')">&times;</span>
      <div class="popup-title">
        [공지] 감사보고서 제출 및 향후 대응 관련 안내
      </div>
      <div class="popup-content">
        <p>안녕하세요. 팡스카이입니다.</p>
        <p>
          당사는 2023 사업연도에 대한 감사보고서를 3월 31일까지 제출하지 못한
          관계로, 4월 7일까지 상장 유지를 위한 감사보고서 제출을 목표로 최선을
          다해 마무리 작업을 진행하였습니다.
        </p>
        <p>
          그러나 일부 채권 정리가 완료되지 않아 회계감사인의 요구 조건을
          충족하지 못하였고, 이에 따라 이번 감사보고서에 대해 ‘의견 거절’을 받는
          결과가 발생하였습니다.
        </p>
        <p>
          이후 관계 기관으로부터 5월 17일까지 이의제기 기간을 부여받아, 당사는
          해당 기간 내에 이의제기를 진행할 예정입니다.<br />
          또한 내부적으로도 사업적 대응 방안을 다각도로 검토 중이며, 이를
          바탕으로 2024년 재무제표에 대한 재감사를 요청할 계획입니다.
        </p>
        <p>
          당사는 모든 이해관계자 여러분께 신뢰를 드릴 수 있도록 성실히 대응해
          나가겠습니다.<br />
          감사합니다.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePopup"
};
</script>

<style lang="scss" scoped>
.home-popup-mask {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); // 稍微加深背景遮罩，提高对比度
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2vw;
}

.home-popup {
  background: #fff;
  padding: 2vw 3.5vw 2vw 3.5vw; // 调整内边距比例
  border-radius: 0.8vw;
  min-width: 24vw;
  max-width: 52vw;
  min-height: 30vh; // 使用vh单位更合理
  width: 100%;
  box-shadow: 0 0.2vw 1.5vw rgba(0, 0, 0, 0.22); // 增强阴影效果
  position: relative;
  animation: popup-in 0.3s ease; // 添加ease缓动效果
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@keyframes popup-in {
  from {
    transform: scale(0.92);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.close-btn {
  position: absolute;
  right: 0.6vw;
  top: -0.2vw;
  font-size: 2.8vw;
  color: #777;
  cursor: pointer;
  transition: all 0.2s ease; // 添加all和ease使过渡更平滑
  &:hover {
    color: #222;
    transform: scale(1.1); // 添加悬停放大效果
  }
}

.popup-title {
  font-size: 1.2vw;
  font-weight: bold;
  margin-bottom: 1vw;
  text-align: center;
  color: #111; // 加深标题颜色
  letter-spacing: 0.02em; // 添加字间距
}

.popup-content {
  font-size: 0.95vw; // 稍微增大字号
  color: #333;
  line-height: 1.8; // 增加行高
  display: flex; // 添加display属性
  flex-direction: column;
  justify-content: center;
  flex: 1;
  p {
    margin-bottom: 0.8vw;
    word-break: break-word; // 使用更现代的word-break值
    &:last-child {
      margin-bottom: 0; // 最后一段无底部间距
    }
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .home-popup-mask {
    padding: 10px;
  }

  .home-popup {
    padding: 28px 16px 24px 16px; // 增加内边距
    min-width: 0;
    max-width: 94vw; // 稍微减小宽度，增加边距
    border-radius: 12px; // 增大圆角
    width: 100%;
    min-height: 70vh; // 增加高度
  }

  .popup-title {
    font-size: 4vw; // 从1.5rem改为5vw
    margin-bottom: 0vw; // 从1.2rem改为3vw
    margin-top: 9vw; // 从1rem改为2vw
  }

  .popup-content {
    font-size: 3.5vw; // 从1.2rem改为4vw
    line-height: 1.6;
    p {
      margin-bottom: 3vw; // 从1rem改为3vw
    }
  }

  .close-btn {
    font-size: 15vw;
    right: 1vw;
    top: -5vw;
  }
}

// 添加平板设备适配
@media (min-width: 769px) and (max-width: 1024px) {
  .home-popup {
    max-width: 70vw;
    min-height: 40vh;
  }

  .popup-title {
    font-size: 2.4vw;
  }

  .popup-content {
    font-size: 1.6vw;
  }
  .close-btn {
    font-size: 8vw;
    right: 0vw;
    top: -3vw;
  }
}
</style>
